import React, { useState } from "react";
import style from "./form-navigation.module.sass";
// import { useLocation } from "react-router";
// import _ from "lodash";
// import { useSelector } from "react-redux";
import { Divider, Popover } from 'antd'
import { formPreview, formSave, HeaderData } from "../../helpers/RxServices";
import { formPreviewType } from "../../helpers/RxServiceTypes";
import DuplicateFormModal from '../../pages/apps/Assisted/forms/create/headerOptions/DuplicateFormModal'
import moreIcon from "../../assets/images/form_icons/moreIcon.svg"
import duplicate from "../../assets/images/form_icons/MoreOptionsIcons/duplicateIcon.svg"
import deleteIcon from "../../assets/images/form_icons/MoreOptionsIcons/deleteIcon.svg"
import editIcon from "../../assets/images/form_icons/MoreOptionsIcons/editIcon.svg"
import settingIcons from "../../assets/images/form_icons/MoreOptionsIcons/settingIcons.svg"
import unselectDestopIcon from "../../assets/images/form_icons/FormBuilder_Autolayout_assets/Preview_desktop_unsel.svg"
import unselectMobileIcon from "../../assets/images/form_icons/FormBuilder_Autolayout_assets/Preview_mobile_unsel.svg"
import selectDestopIcon from "../../assets/images/form_icons/FormBuilder_Autolayout_assets/Preview_desktop_sel.svg"
import selectMobileIcon from "../../assets/images/form_icons/FormBuilder_Autolayout_assets/Preview_mobile_sel.svg"
import { logger } from "../../constant/winston";











// import { AppState } from "../../stateManager/store";
// import { store } from "../../stateManager";
interface Iprops {
  handleshowView: (key: string) => void
}

export const Header: React.FC<Iprops> = (props) => {
  // const paths = useLocation().pathname.split("/");
  const [button, setButton] = useState({ preview: false, save: false, morePopver: false })
  const [headerData, setheaderData] = useState<any>([])
  const [duplicateState, setduplicateState] = useState({ visible: false })
  const [moreOptionState, setmoreOptionState] = useState({ visible: false })
  const [destopView, setDestopView] = useState(true)
  const [mobileView, setMobileView] = useState(false)






  formPreview.getMessage().subscribe((res: formPreviewType) => {


    if (res && res.hide) {
      setButton(res.hide);
    }
  })

  // let appId: any, formId: any;
  // if (paths.length === 9) {
  //   appId = paths[4];
  //   formId = paths[7];
  // }

  // const headers: any = useSelector((state: AppState) => {
  //   return {
  //     app: _.find(state.apps, ["id", appId]),
  //     forms: _.find(state.forms, ["id", formId])
  //   };
  // });
  let handleDuplicateSetState = () => {
    setduplicateState({ visible: true })
    setmoreOptionState({ visible: false })
  }
  const morePopovercontent = (
    <div className={style.moreOptionContent_Main}  >
      <div className={style.moreOptionContent_Inner} >
        <img src={settingIcons} className={style.moreOptionContent_Img} alt="morIcon" />
        <div>Form Properties</div>
      </div>
      <div data-test-id="duplicate" className={style.moreOptionContent_Inner} onClick={handleDuplicateSetState}>
        <img src={duplicate} alt="morIcon" className={style.moreOptionContent_Img} />
        <div>  Duplicate</div>
      </div>
      <div data-test-id="edit" className={style.moreOptionContent_Inner}>
        <img src={editIcon} alt="morIcon" className={style.moreOptionContent_Img} />
        <div>  Edit</div>
      </div>
      <div data-test-id="delete" className={style.moreOptionContent_Inner} style={{ paddingBottom: "0px" }}>
        <img src={deleteIcon} alt="morIcon" className={style.moreOptionContent_Img} />
        <div>  Delete</div>
      </div>
    </div>
  );
  HeaderData.getMessage().subscribe((res: any) => {
    setheaderData(res)
  })
  const handleViews = (key: string) => () => {

    props.handleshowView(key)
    if (key === "destop") {
      if (destopView && !mobileView) {
        logger.debug("desktop view")
      } else {
        setDestopView(!destopView)

      }
    } else {
      if (mobileView && !destopView) {
        logger.debug("mobile view")
      } else {
        setMobileView(!mobileView)
      }
    }

  }

  const currentVersion = headerData && headerData.length > 0 && headerData[0].currentVersion;
  return (
    <div className={style.header + " row"}>
      <div className={style.front + " col-md-4"}>
        <div className={style.a8Logo + " "}>
          <span>A8</span>
          <span>Studio</span>
        </div>
      </div>
      <div className={style.center + " col-md-2"}>
        <div className={style.headernames + " row"}>
          {
            headerData && headerData.length > 0 &&
            <React.Fragment>
              <h4>{headerData[0].appName}</h4>
              <h5>{headerData[0].formName}</h5>
            </React.Fragment>
          }
        </div>
      </div>
      <div className={style.center + " col-md-2"}>

        <React.Fragment>
          <span> <img data-test-id="desktop" onClick={handleViews("destop")} src={destopView ? selectDestopIcon : unselectDestopIcon} style={{ paddingRight: "31px" }} alt="destopIcon" /></span>
          <span> <img data-test-id="mobile" onClick={handleViews("mobile")} src={mobileView ? selectMobileIcon : unselectMobileIcon} alt="mobileIcon" /></span>
        </React.Fragment>
      </div>


      <div className={style.last + " col-md-6"}>
        {!button.morePopver && currentVersion && <Divider type={"vertical"} style={{ height: "45px", margin: "0px 30px" }} />}
        {!button.morePopver && currentVersion && <Popover placement="bottom" content={morePopovercontent}
          visible={moreOptionState.visible}
          trigger="click"
          onVisibleChange={(e) => {
            setmoreOptionState({ visible: e })
          }}
        >
          <img data-test-id="more_icon" src={moreIcon} alt="morIcon" style={{ cursor: "pointer" }} onClick={() => {
            setmoreOptionState({ visible: true })
          }} />
        </Popover>}
        {!button.morePopver && currentVersion && <Divider type={"vertical"} style={{ height: "45px", margin: "0px 30px" }} />}
        <div className={style.buttons + " row"}>
          {
            !button.preview && <button data-test-id="preview" className={style.preview} onClick={() => formPreview.sendMessage({ from: 'preview' })} >PREVIEW</button>
          }
          {
            !button.save && currentVersion && <button data-test-id="save" className={style.save} onClick={() => formSave.sendMessage({ from: 'save' })} >Save</button>
          }
        </div>

      </div>
      <DuplicateFormModal
        visible={duplicateState.visible}
        setvisible={(e: any) => {
          setduplicateState({ visible: e })
        }}
        appType="assisted"
      />

    </div>
  );
};

export default Header;


